export default {
  'pages.layouts.userLayout.title':
    'Ant Designは、西湖区で最も影響力のあるWebデザイン仕様です。',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.accountLogin.errorMessage':
    'ユーザー名/パスワードが正しくありません(admin/ant.design)',
  'pages.login.failure': 'ログインに失敗したら、もう一度試してください!',
  'pages.login.success': 'ログイン成功!',
  'pages.login.username.placeholder': 'ユーザー名：adminまたはuser',
  'pages.login.username.required': 'ユーザー名を入力してください！',
  'pages.login.password.placeholder': 'パスワード：ant.design',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneLogin.errorMessage': '検証コードエラー',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.captcha.placeholder': '確認コード',
  'pages.login.captcha.required': '確認コードを入力してください！',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.getCaptchaSecondText': '秒',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'パスワードをお忘れですか？',
  'pages.login.submit': 'ログイン',
  'pages.login.loginWith': 'その他のログイン方法：',
  'pages.login.registerAccount': 'アカウント登録',
  'pages.welcome.link': 'ようこそ',
  'pages.welcome.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  
  // Order Statistics Page
  'pages.orders.statistics.title': '注文統計',
  'pages.orders.statistics.dateRange': '照会期間',
  'pages.orders.statistics.last7Days': '過去7日',
  'pages.orders.statistics.last30Days': '過去30日',
  'pages.orders.statistics.last90Days': '過去90日',
  'pages.orders.statistics.totalOrders': '総注文数',
  'pages.orders.statistics.totalSales': '売上高',
  'pages.orders.statistics.refundCount': '返品商品数',
  'pages.orders.statistics.refundAmount': '返金額',
  'pages.orders.statistics.trendChart': '営業トレンドグラフ',
  'pages.orders.statistics.dailyStats': '日次統計',
  'pages.orders.statistics.chart.orders': '注文数',
  'pages.orders.statistics.chart.revenue': '売上高',
  'pages.orders.statistics.chart.refunds': '返品数',
  'pages.orders.statistics.table.date': '日付',
  'pages.orders.statistics.table.orderCount': '注文数',
  'pages.orders.statistics.table.revenue': '売上高',
  'pages.orders.statistics.table.refundCount': '返品数',
  'pages.orders.statistics.table.refundAmount': '返金額',
  'pages.orders.statistics.table.total': '合計 {total} 件',

  // ライブリベート設定
  'pages.live.rebate.title': 'ライブリベート設定',
  'pages.live.rebate.liveTeamName': 'ライブチーム名',
  'pages.live.rebate.memberId': '会員ID',
  'pages.live.rebate.sellerId': '販売者ID',
  'pages.live.rebate.sellerPercent': '販売者%',
  'pages.live.rebate.companyPercent': '会社%',
  'pages.live.rebate.teamPercent': 'チーム%',
  'pages.live.rebate.teamRebatePercent': 'チームリベート%',
  'pages.live.rebate.settingTimeAdmin': '設定時間/管理者',
  'pages.live.rebate.actions': '操作',
  'pages.live.rebate.setting': '設定',
  'pages.live.rebate.detail': '詳細',
  'pages.live.rebate.delete': '削除',
  'pages.live.rebate.addRebate': 'リベート追加',
  'pages.live.rebate.batchUpdate': '一括更新',
  'pages.live.rebate.selectFirst': '先に項目を選択してください',
  'pages.live.rebate.addSuccess': 'リベートが正常に追加されました',
  'pages.live.rebate.addFailed': 'リベートの追加に失敗しました',
  'pages.live.rebate.updateSuccess': 'リベートが正常に更新されました',
  'pages.live.rebate.updateFailed': 'リベートの更新に失敗しました',
  'pages.live.rebate.deleteSuccess': 'リベートが正常に削除されました',
  'pages.live.rebate.deleteFailed': 'リベートの削除に失敗しました',
  'pages.live.rebate.deleteConfirm': 'リベート削除',
  'pages.live.rebate.deleteContent': 'このリベート設定を削除しますか？',
  'pages.live.rebate.addModalTitle': 'リベート設定追加',
  'pages.live.rebate.editModalTitle': 'リベート設定編集',
  'pages.live.rebate.liveTeamNameRequired': 'ライブチーム名を入力してください',
  'pages.live.rebate.memberIdRequired': '会員IDを入力してください',
  'pages.live.rebate.sellerIdRequired': '販売者IDを入力してください',
  'pages.live.rebate.sellerPercentRequired': '販売者パーセンテージを入力してください',
  'pages.live.rebate.companyPercentRequired': '会社パーセンテージを入力してください',
  'pages.live.rebate.teamPercentRequired': 'チームパーセンテージを入力してください',
  'pages.live.rebate.teamRebatePercentRequired': 'チームリベートパーセンテージを入力してください',
  'pages.live.rebate.loadFailed': 'リベート設定の読み込みに失敗しました',
  'pages.live.rebate.selectAtLeastTwo': '2つ以上の項目を選択してください',
  'pages.live.rebate.batchSetting': '一括設定',
  'pages.live.rebate.batchUpdateTitle': 'パーセンテージ一括更新',
  'pages.live.rebate.selectedItems': '件選択中',
  'pages.live.rebate.applySetting': '設定適用',
  'pages.live.rebate.cancel': 'キャンセル',
  'pages.live.rebate.batchUpdateSuccess': '一括更新が正常に完了しました',
  'pages.live.rebate.batchUpdateFailed': '一括更新に失敗しました',
  'pages.live.rebate.searchLabel': '検索',
  'pages.live.rebate.searchPlaceholder': 'ライブチーム名、販売者IDまたは会員IDで検索',
  'pages.live.rebate.search': '検索',
  'pages.live.rebate.reset': 'リセット',
  'pages.live.rebate.teamLead': 'チームリーダー',
  'pages.live.rebate.teamLeadId': 'チームリーダーID',
  'pages.live.rebate.teamLeadIdRequired': 'チームリーダーIDを入力してください',
  'pages.live.rebate.teamInternalSelfPercent': 'チーム内部自己%',
  'pages.live.rebate.teamInternalSelfPercentRequired': 'チーム内部自己パーセンテージを入力してください',
  'pages.live.rebate.teamInternalUplinePercent': 'チーム内部上位%',
  'pages.live.rebate.teamRebate': 'チームリベート',
  'pages.live.rebate.memberSettings': 'メンバー設定',
  'pages.live.rebate.memberSettingsTitle': 'セラー別リベート設定',
  'pages.live.rebate.memberSettingsHint': '個別セラーのリベート%を設定します。保存するとそのセラーの精算にはチーム設定の代わりにこの値が使用されます。「未設定」のセラーにはチーム設定が適用されます。',
  'pages.live.rebate.memberSource': '設定元',
  'pages.live.rebate.memberSourceTeamCopy': 'チームからコピー',
  'pages.live.rebate.memberSourceAdmin': '個別設定',
  'pages.live.rebate.memberSourceNone': '未設定（チーム設定を適用）',
  'pages.live.rebate.memberSourceTeamConfig': 'チーム設定',
  'pages.live.rebate.memberSelfPercent': '自己保有 %',
  'pages.live.rebate.memberSave': '保存',
  'pages.live.rebate.memberSaveSuccess': 'セラーリベート設定を保存しました',
  'pages.live.rebate.memberSaveFailed': 'セラーリベート設定の保存に失敗しました',
  'pages.live.rebate.memberLoadFailed': 'チームメンバーの読み込みに失敗しました',
  'pages.live.rebate.marginSumError': 'セラー+会社+チーム%の合計は100である必要があります',
  'pages.live.rebate.teamLeadTag': 'チームリーダー',
  'pages.live.rebate.teamInternalUplinePercentRequired': 'チーム内部上位パーセンテージを入力してください',
  'pages.live.rebate.configuredAt': '設定日時',
  'pages.live.rebate.configuredAtRequired': '設定日時を選択してください',
  'pages.live.sellers.userId': 'ユーザー ID',
  'pages.live.sellers.sellerId': 'セラー ID',
  'pages.live.sellers.name': '名前',
  'pages.live.sellers.recommender': '紹介者',
  'pages.live.sellers.team': 'チーム人数',
  'pages.live.sellers.follower': 'フォロワー',
  'pages.live.sellers.salesAmount': '売上金額',
  'pages.live.sellers.salesCount': '販売数',
  'pages.live.sellers.rebate': 'リベート累計',
  'pages.live.sellers.refundAmount': '返金額',
  'pages.live.sellers.rebateDeduction': 'リベート控除',
  'pages.live.sellers.liveStatus': 'ライブ状態',
  'pages.live.sellers.liveStatus.live': 'ライブ中',
  'pages.live.sellers.liveStatus.idle': '待機',
  'pages.live.sellers.homepage': 'ホームページ',
  'pages.live.sellers.homepageLink': 'リンク',
  'pages.live.sellers.sellerMailbox': 'セラーメールボックス',
  'pages.live.sellers.sellerNickname': 'セラーニックネーム',
  'pages.live.sellers.rebateAccrued': 'リベート累計',
  'pages.live.sellers.rebateDeducted': 'リベート控除',
  'pages.live.sellers.deposit': '預り金',
  'pages.live.sellers.livePage': 'ライブページ',
  'pages.live.sellers.actions': '操作',
  'pages.live.rebate.levelDetailTitle': 'ライブチームリスト',
  'pages.live.rebate.levelDetail.column.teamName': 'チーム名',
  'pages.live.rebate.levelDetail.column.depth': 'レベル',
  'pages.live.rebate.levelDetail.column.userUniqueId': '販売者ID',
  'pages.live.rebate.levelDetail.column.userId': 'ユーザーID',
  'pages.live.rebate.levelDetail.column.userName': 'ユーザー名',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': '下位販売者数',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': '売上金額 (KRW)',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': 'マージン金額 (KRW)',
  'pages.live.rebate.levelDetail.column.salesQuantity': '売上数量',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': '返金額 (KRW)',
  'pages.live.rebate.levelDetail.column.refundQuantity': '返金数量',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': 'チームリベート累計 (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': 'チームリベート控除 (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': '返金後チームリベート (KRW)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': '会社累計 (KRW)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': '会社控除 (KRW)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': '返金後会社 (KRW)',
  'pages.live.rebate.levelDetail.column.action': '操作',
  'pages.live.rebate.levelDetail.searchLabel': '検索：',
  'pages.live.rebate.levelDetail.searchPlaceholder': '販売者ID、ユーザーIDまたはユーザー名で検索...',
  'pages.live.rebate.levelDetail.searchButton': '検索',
  'pages.live.rebate.levelDetail.resetButton': 'リセット',
  'pages.live.rebate.levelDetail.reloadButton': '再読み込み',
  'pages.live.rebate.levelDetail.detailButton': '詳細',
  'pages.live.rebate.levelDetail.loadError': 'ライブリベート詳細データの読み込みに失敗しました',
  'pages.live.rebate.levelDetail.level1': 'レベル 1',
  'pages.live.rebate.levelDetail.level2': 'レベル 2',
  'pages.live.rebate.levelDetail.level3': 'レベル 3',
  'pages.live.rebate.levelDetail.level4': 'レベル 4',
};
